import { useState } from 'react'
import Tabs from './Tabs'
import Legend from './Legend'
import MixLabels from './MixLabels'
import Risk from './Risk'
import Breakdown from './Breakdown'
import _ from 'lodash'

const categoryOrder = { Cash: 1, Bonds: 2, Stocks: 3, Misc: 4 }

function InvestmentMixChart(props) {
  const [active, setActive] = useState(props.defaultState || 'assetClassBreakdown')

  function handleChange(value) {
    setActive(value)
  }

  const { allTabsEnabled, store, ...restProps } = props
  const { allBreakdown } = store
  const selectedBreakdown =
    allBreakdown.filter(account => account.name === props.selectedaccount)[0] || []
  const sortedBreakdown = _.sortBy(selectedBreakdown[active], [
    category => categoryOrder[category.name],
  ])
  const anyOldValues =
    sortedBreakdown.filter(
      x =>
        x.assets.filter(asset => {
          return asset.oldValue !== null
        }).length > 0
    ).length > 0

  // Hide the Old Mix for Asset Class Breakdown Tab
  const hideOld = active === 'assetClassBreakdown'
  const hideOldRisk = active === 'assetClassBreakdown' || !anyOldValues

  return (
    <div {...restProps}>
      <Tabs
        store={store}
        active={active}
        handleChange={handleChange}
        allTabsEnabled={allTabsEnabled}
      />

      <Legend />

      <MixLabels hideOld={hideOld} />

      <Risk store={store} hideOld={hideOldRisk} />

      <Breakdown active={active} hideOld={hideOld} sortedBreakdown={sortedBreakdown} />
    </div>
  )
}

export default InvestmentMixChart
